import {
  getIsMatchCriterionNotApplicable,
  getMatchCriteria,
  getMatchCriterionLabelKey,
} from '../RentalPortalMatch.utils'

import { MATCH_CHIPS_VISIBLE_LIMIT } from './RentalPortalMatchChipsCell.constants'

function getMatchChipCriteria(match) {
  return getMatchCriteria(match).filter(
    criterion => !getIsMatchCriterionNotApplicable(criterion)
  )
}

export function getMatchChips(match) {
  const criteria = getMatchChipCriteria(match)

  return {
    chips: criteria.slice(0, MATCH_CHIPS_VISIBLE_LIMIT),
    restCount: Math.max(criteria.length - MATCH_CHIPS_VISIBLE_LIMIT, 0),
  }
}

export function getMatchChipsExportValue({ match, t }) {
  return getMatchChipCriteria(match)
    .map(criterion => t(getMatchCriterionLabelKey(criterion.key)))
    .join(', ')
}

export function getHasMatchChipsRest(restCount) {
  return restCount > 0
}
